import { Expose } from "class-transformer";
import { DropdownModel } from "./dropdown-model";

export class SessionSlotsModel extends DropdownModel {
    @Expose() id: string;
    @Expose() startTime: number;
    @Expose() endTime: number;

    override get dropDownDisplayName(): string {
        return `${this.startTime}-${this.endTime}`
    }
    
    override get dropDownValue(): Object {
        return this;
    }
}